export const formatByteSize = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export const formatFileSize = (bytes: number | string | null | undefined): string => {
    if (!bytes && bytes !== 0) return '—';
    const numBytes = typeof bytes === 'string' ? parseFloat(bytes) : bytes;
    if (isNaN(numBytes) || numBytes < 0) return '—';
    if (numBytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    let size = numBytes;
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(unitIndex === 0 ? 0 : 2)} ${units[unitIndex]}`;
}

export const truncarNomeArquivo = (nome: string, tamanhoMaximo: number = 40): string => {
    if (nome.length <= tamanhoMaximo) {
        return nome;
    }
    
    const pontoIndex = nome.lastIndexOf('.');
    if (pontoIndex === -1) {
        return nome.substring(0, tamanhoMaximo - 3) + '...';
    }
    
    const extensao = nome.substring(pontoIndex);
    const nomeSemExtensao = nome.substring(0, pontoIndex);
    const espacoDisponivel = tamanhoMaximo - extensao.length - 3;
    
    if (espacoDisponivel <= 0) {
        return nome.substring(0, tamanhoMaximo - 3) + '...';
    }
    
    return nomeSemExtensao.substring(0, espacoDisponivel) + '...' + extensao;
}